// resources/js/foodilo/appMode.ts
import { Capacitor } from '@capacitor/core';

export function isFoodiloApp(): boolean {
    try {
        return Capacitor.isNativePlatform();
    } catch {
        return false;
    }
}
